import React from 'react';
import styles from "../help.scss";
import { StaticHTML } from "../../StaticHTML";
import HelmetComponent from "../../../utils/HelmetHelper";
import { getImageUrl } from '../../../services/asset';
import { Collapse } from 'antd';
const { Panel } = Collapse;

const corvusPay = getImageUrl('help/paymentMethods/corvus-pay.png');
const mastercard = getImageUrl('help/paymentMethods/mastercard.png');
const maestro = getImageUrl('help/paymentMethods/maestro.png');
const visa = getImageUrl('help/paymentMethods/visa.png');
const diners = getImageUrl('help/paymentMethods/diners.png');


//panel content
const panelCreditCardsFirst = `
      <p><strong>Plaćanje karticama</strong></p>
      <p>Ukoliko odaberete plaćanje karticom Vaša će uplata biti automatski provedena.</p>
      
      <br/>
      
      <p><strong>Način i uvjeti plaćanja</strong></p>
      <p>Svi oglasi i usluge naručeni za objavu putem jednog od ponuđenih oglasnih proizvoda ili paketa naplaćuju se prije izvršenja. Kupac ili oglašivač prihvaća plaćanje iznosa cijene proizvoda prikazanog na stranicama za predaju, pregled i potvrdu oglasnog proizvoda na stranici oglasa. Kupac ili oglašivač može otkazati plaćanje u bilo kojem trenutku do konačne potvrde plaćanja iznosa na stranicama CorvusPay. Index Promocija d.o.o. zadržava pravo ne objaviti oglas ukoliko je isti u suprotnosti s Pravilima i uvjetima korištenja.</p>
      
      <br/>

      <p><b>Sigurna online autorizacija i plaćanje</b></p>
      <p><img src="${corvusPay}" alt="corvusPay" style="max-width: 150px" /></p>
      <p>Pri plaćanju na Index Oglasima koristite CorvusPay – napredni sustav za siguran prihvat platnih kartica putem interneta. CorvusPay osigurava potpunu tajnost kartičnih podataka već od trenutka kada ih unesete u CorvusPay platni obrazac. Platni podaci se prenose šifrirano od web preglednika do banke koja je izdala karticu. Index Oglasi nikada ne dolaze u kontakt s cjelokupnim podacima o platnoj kartici. Također, podaci su nedostupni čak i zaposlenicima u sustavu CorvusPay. Izolirana jezgra samostalno prenosi i upravlja osjetljivim podacima, čuvajući ih pritom potpuno sigurnima.</p>
      `;

const panelCreditCardsSecond = `
      <br />
      <br />
      <p><strong>Izjava o zaštiti podataka</strong></p>
      <p>Index Promocija d.o.o. obavezuje se pružati zaštitu osobnim podacima kupaca, na način da prikuplja samo nužne, osnovne podatke o kupcima/ korisnicima koji su nužni za ispunjenje naših obveza; informira kupce o načinu korištenja prikupljenih podataka, redovito daje kupcima mogućnost izbora o upotrebi njihovih podataka, uključujući mogućnost odluke žele li ili ne da se njihovo ime ukloni s lista koje se koriste za marketinške kampanje. Svi se podaci o korisnicima strogo čuvaju i dostupni su samo djelatnicima kojima su ti podaci nužni za obavljanje posla. Svi djelatnici Index Promocija d.o.o. i poslovni partneri odgovorni su za poštovanje načela zaštite privatnosti.</p>
      <p>
        <b>Index Promocija d.o.o. </b><br />
        Radnička cesta 41<br />
        10000 Zagreb, Hrvatska<br />
        Tel: <a href="tel:01/777-55-32" style="color:#f94144">01/777-55-32<a/><br />
        E-mail: <a href="mailto:oglasi@index.hr" style="color:#f94144">oglasi@index.hr</a>
      </p>
      <p>Društvo je upisano u sudski registar kod Trgovačkog suda u Zagrebu, MBS: 080704131</p>
`;


const panelBankTransfer = `
      <p><strong>Uplatnica, internet bankarstvo</strong></p>
      <p>U slučaju plaćanja općom uplatnicom ili internet bankarstvom, uplata će biti proknjižena za 1-3 radna dana. Uplatnicu sa svim potrebnim podacima možete uplatiti na bilo kojoj poslovnici fine,u svim poštanskim uredima ili internet bankarstvom bilo koje banke.</p>
`;

const panelStoreCredit = `
      <p><strong>Krediti</strong></p>
      <p>Krediti su najpovoljniji i najbrži način plaćanja na stranici. Mogu se koristiti za aktiviranje usluga promocije, koje povećavaju vidljivost oglasa i tako utječu na brzinu prodaje.</p>
`;

//styling
const customPanelStyle = {
  background: '#f9f9f9',
  border: 0
};

function PaymentMethods() {
  return (
    <div className={styles.container}>
      <HelmetComponent
        title={`${"Načini plaćanja"} | ${"INDEX OGLASI"}`}
      />
      <div className={styles.title}>Načini plaćanja</div>
      <Collapse
        bordered={false}
        defaultActiveKey={["1", "2", "3"]} // open all 
      >
        <Panel header={"KARTICE"} key="1" style={customPanelStyle}>
          <StaticHTML content={panelCreditCardsFirst} />
            <div className={styles.paymentsLogos}>
              <img className={styles.mastercard} src={mastercard} alt="Mastercard" />
              <img className={styles.maestro} src={maestro} alt="Maestro" />
              <img className={styles.visa} src={visa} alt="Visa" />
              <img className={styles.diners} src={diners} alt="Diners" />
            </div>

          <StaticHTML content={panelCreditCardsSecond} />
        </Panel>
        <Panel header={"UPLATNICA, INTERNET BANKARSTVO"} key="2" style={customPanelStyle}>
          <StaticHTML content={panelBankTransfer} />
        </Panel>
        <Panel header={"KREDITI NA SALDO"} key="3" style={customPanelStyle}>
          <StaticHTML content={panelStoreCredit} />
        </Panel>
      </Collapse>
    </div>
  );
}

export default PaymentMethods;






// WEBPACK FOOTER //
// ./src/components/Help/PaymentMethods/PaymentMethods.tsx